import React from "react";
import { ReactComponent as Logo } from "images/Logo.svg";

type Props = {
  children?: React.ReactNode;
};

const DesktopContainerAuth: React.FC<Props> = ({ children }) => {
  return (
    <div className="w-full h-full bg-bt-green-bridge">
      <div className="justify-center flex flex-row items-center max-h-login-web min-h-desktop-container">
        <div className="flex flex-col items-center h-full w-1/2">
          <Logo />
        </div>
        <div className="flex flex-col bg-bt-white items-center w-1/2 max-h-login-web min-h-desktop-container">
          <div className="my-auto">{children}</div>
        </div>
      </div>
    </div>
  );
};

export default DesktopContainerAuth;
